import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const Interfaces = React.lazy(async () => ({
    default: (await import('@oc/interfaces/module')).InterfacesModule
}))

export function InterfacesComponent() {
    return <SuspenseWhileLoading LazyComponent={Interfaces} />
}
